import React, { useState,useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import MenuBar from "./MenuBar";
import Footer from "./Footer";
import WeeklyScheduleModal from "./WeeklyScheduleModal";
import envVariable from "../EnvironmentVariables.json";
import "./Style.css";
import { NotificationContext } from "../redux/NotificationProvider";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
//import { NavLink } from "react-router-dom";



const AddEmployee = () => {
  const SC_Id = localStorage.getItem("SC_Id");
  const navigate = useNavigate();
  const notify = useContext(NotificationContext);

  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [pendingSchedule, setPendingSchedule] = useState(null); // Store schedule until employee is saved

  // State for form fields
  const [employee, setEmployee] = useState({
    serviceCenterName: "",
    password: "",
    confirmPass: "",
    firstName: "",
    lastName: "",
    email: "",
    role: "Mechanic",
    skill: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    contactNumber: "",
    SC_Id: SC_Id,

    // Two important fields for the new logic:
    isExistingUser: false,
    userId: null, // We will fill this if we find the user in DB
  });

  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee({ ...employee, [name]: value });
  };

  const validateForm = () => {
    const errors = {};
    const fields = [
      "password",
      "confirmPass",
      "firstName",
      "lastName",
      "email",
      "role",
      "skill",
      "addressLine1",
      "city",
      "state",
      "country",
      "zipCode",
      "contactNumber",
    ];

    fields.forEach((field) => {
      const val = employee[field];
      if (typeof val === "string" && !val.trim()) {
        errors[field] = `${field} is required`;
      } else if (field === "email" && !/^\S+@\S+\.\S+$/.test(val)) {
        errors.email = "Invalid email format";
      } else if (field === "contactNumber" && !/^\d{10}$/.test(val)) {
        errors.contactNumber = "Invalid phone number, must be 10 digits";
      } else if (field === "zipCode" && !/^\d{5}$/.test(val)) {
        errors.zipCode = "Invalid zip code, must be 5 digits";
      }
      if(field == "firstName" && val.length > 20) {
          errors.firstName = "First Name should not exceed 20 characters";
      }
      if(field == "lastName" && val.length > 20) {
          errors.lastName = "Last Name should not exceed 20 characters";
      }
    });

    if (employee.confirmPass !== employee.password) {
      errors["confirmPass"] = "Confirm password doesn't match password";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const checkExistingUser = async () => {
    try {
      const response = await fetch(`${envVariable.serverId}/SCO/GetExistingUser.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: employee.email,
          password: employee.password,
        }),
      });

      const data = await response.json();
      console.log("Check Existing User response:", data);

      if (data.status === "Success" && data.user) {
        // If user is found, we store the userId and isExistingUser = true
        setEmployee({
          ...employee,
          isExistingUser: true,
          userId: data.user.user_id, // or whatever your backend returns
          firstName: data.user.first_name,
          lastName: data.user.last_name,
          contactNumber: data.user.phone,
          addressLine1: data.user.address1,
          addressLine2: data.user.address2,
          city: data.user.city,
          state: data.user.state,
          country: data.user.country,
          zipCode: data.user.zipcode,
          skill: data.user.skills,
          // Clear out the password fields if you want them empty
          password: "",
          confirmPass: "",
        });
        notify("Existing user found. Fields have been updated from the DB successfully","success");
      } else {
        // No matching user found
        setEmployee({ ...employee, isExistingUser: false, userId: null });
        notify(data.message || "No existing user found with this email/password.","error");
      }
    } catch (error) {
      console.error("Error checking user:", error);
      notify("Error checking existing user. Please try again.","error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handleSubmit called");

    // We do NOT block submission if isExistingUser == true.
    // The backend will handle whether to reactivate or update.

    if (!validateForm()) {
      console.log("Form validation failed:", JSON.stringify(formErrors, null, 2));
      return;
    }

    console.log("Form validation passed, submitting data:", employee);
    
    try {
      const response = await fetch(`${envVariable.serverId}/SCO/AddEmployee.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(employee),
      });

      const data = await response.json();
      console.log("Server response:", data);

      if (data.status === "Success") {
        const newEmployeeId = data.user_id || employee.userId; // Get the newly created or updated user_id

        // If there's a pending schedule, save it now
        if (pendingSchedule && employee.role === 'Mechanic') {
          try {
            await savePendingSchedule(newEmployeeId);
            notify("Employee and weekly schedule added successfully!", "success");
          } catch (scheduleError) {
            console.error("Error saving schedule:", scheduleError);
            notify("Employee added but failed to save schedule. Please edit the employee to set their schedule.", "warning");
          }
        } else {
          notify("Employee added (or updated/reactivated) successfully!", "success");
        }

        navigate("/employees");
      } else {
        notify("Failed to add/update employee: " + (data.message || "Unknown error"),"error");
      }
    } catch (error) {
      console.error("Error adding employee:", error);
      notify("An error occurred while adding the employee. Please try again.","error");
    }
  };

  const savePendingSchedule = async (userId) => {
    if (!pendingSchedule || pendingSchedule.length === 0) return;

    const apiKey = localStorage.getItem('api_key') || localStorage.getItem('@api_key') || '';
    const response = await fetch(`${envVariable.serverId}/WeeklySchedule/saveWeeklySchedule.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": apiKey
      },
      body: JSON.stringify({
        mechanic_id: userId,
        sc_id: SC_Id,
        schedule_blocks: pendingSchedule
      }),
    });

    const data = await response.json();
    if (data.type !== "success") {
      throw new Error(data.message || "Failed to save schedule");
    }
  };

  const [backConfirmOpen, setBackConfirmOpen] = useState(false);

  return (
    <>
      <MenuBar />
      <Box p={3} className="add-employee-container">
        <Typography variant="h4" align="center" gutterBottom>
          Add Employee
        </Typography>
        <form onSubmit={handleSubmit} className="add-employee-form">
          <Grid container spacing={2} justifyContent="center">
            {/* Email Field */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={employee.email}
                onChange={handleChange}
                error={!!formErrors.email}
                helperText={formErrors.email}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>

            {/* Password Field */}
            <Grid item xs={6} sm={6}>
              <TextField
                fullWidth
                type="password"
                label="Password"
                name="password"
                value={employee.password}
                onChange={handleChange}
                error={!!formErrors.password}
                helperText={formErrors.password}
              />
            </Grid>

            {/* First Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={employee.firstName}
                onChange={handleChange}
                error={!!formErrors.firstName}
                helperText={formErrors.firstName}
              />
            </Grid>

            {/* Confirm Password */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="password"
                label="Confirm Password"
                name="confirmPass"
                value={employee.confirmPass}
                onChange={handleChange}
                error={!!formErrors.confirmPass}
                helperText={formErrors.confirmPass}
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={employee.lastName}
                onChange={handleChange}
                error={!!formErrors.lastName}
                helperText={formErrors.lastName}
              />
            </Grid>

            {/* Contact Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Contact Number (i.e. 1234567890)"
                name="contactNumber"
                value={employee.contactNumber}
                onChange={handleChange}
                error={!!formErrors.contactNumber}
                helperText={formErrors.contactNumber}
              />
            </Grid>

            {/* Role */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!formErrors.role}>
                <InputLabel id="role-id">Role</InputLabel>
                <Select label="role-id" name="role" value={employee.role} onChange={handleChange}>
                  <MenuItem value="Mechanic">Mechanic</MenuItem>
                  <MenuItem value="Manager">Manager</MenuItem>
                  <MenuItem value="Front Desk">Front Desk</MenuItem>
                </Select>
                {formErrors.role && (
                  <Typography variant="caption" color="error">
                    {formErrors.role}
                  </Typography>
                )}
              </FormControl>
            </Grid>

            {/* Skill */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Skill"
                name="skill"
                value={employee.skill}
                onChange={handleChange}
                error={!!formErrors.skill}
                helperText={formErrors.skill}
              />
            </Grid>

            {/* Address Line 1 */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Address Line 1"
                name="addressLine1"
                value={employee.addressLine1}
                onChange={handleChange}
                error={!!formErrors.addressLine1}
                helperText={formErrors.addressLine1}
              />
            </Grid>

            {/* Address Line 2 */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Address Line 2 (Optional)"
                name="addressLine2"
                value={employee.addressLine2}
                onChange={handleChange}
              />
            </Grid>

            {/* City */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={employee.city}
                onChange={handleChange}
                error={!!formErrors.city}
                helperText={formErrors.city}
              />
            </Grid>

            {/* State */}
            <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!formErrors.state}>
              <InputLabel>State</InputLabel>
              <Select
                name="state"
                value={employee.state}
                onChange={handleChange}
                label="State"
              >
                {[
                  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
                  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
                  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
                  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
                  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
                  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
                  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
                  "Wisconsin", "Wyoming"
                ].map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.state && (
                <Typography variant="caption" color="error">
                  {formErrors.state}
                </Typography>
              )}
            </FormControl>
            </Grid>

            {/* Country */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={employee.country}
                onChange={handleChange}
                error={!!formErrors.country}
                helperText={formErrors.country}
              />
            </Grid>

            {/* Zip Code */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Zip Code"
                name="zipCode"
                value={employee.zipCode}
                onChange={handleChange}
                error={!!formErrors.zipCode}
                helperText={formErrors.zipCode}
              />
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} sm={12} mt={2}>
              
              <Button
                variant="contained"
                color="primary"
                onClick={() => setBackConfirmOpen(true)}
                sx={{ mr: 2 , backgroundColor: "#B21102", "&:hover": {backgroundColor: "#990F02"}}}
              >
                Back to Employees
              </Button>
              
              {/* <Button
                component={NavLink}
                to="/employees"
                variant="contained"
                color="primary"
                sx={{ mr: 2, backgroundColor: "#990F02", color: "white" }}
              >
                Back to Employees
              </Button> */}
                          
              
              {/* 1) Add/Update Employee */}
              <Button variant="contained" color="primary" type="submit" sx={{ mr: 2 }}>
                Add/Update Employee
              </Button>

              {/* 2) Check Existing User */}
              <Button variant="contained" onClick={checkExistingUser} color="secondary" type="button" sx={{ mr: 2 }}>
                Check Existing User
              </Button>

              {/* 3) Weekly Schedule */}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: employee.role === 'Mechanic' ? '#4CAF50' : '#cccccc',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: employee.role === 'Mechanic' ? '#45a049' : '#cccccc',
                  },
                  cursor: employee.role === 'Mechanic' ? 'pointer' : 'not-allowed',
                  opacity: employee.role === 'Mechanic' ? 1 : 0.6
                }}
                onClick={() => employee.role === 'Mechanic' && setScheduleModalOpen(true)}
                disabled={employee.role !== 'Mechanic'}
                title={employee.role !== 'Mechanic' ? 'Weekly schedule is only available for mechanics' : 'Set weekly schedule (will be saved when employee is added)'}
                type="button"
              >
                Weekly Schedule
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
      <WeeklyScheduleModal
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        mechanic={{
          user_id: null, // No user_id yet - will be handled after employee is created
          first_name: employee.firstName,
          last_name: employee.lastName
        }}
        scId={SC_Id}
        onScheduleSave={(schedule) => {
          setPendingSchedule(schedule);
          setScheduleModalOpen(false);
          notify("Weekly schedule configured. It will be saved when you add the employee.", "info");
        }}
        isAddMode={true} // Flag to indicate we're in add mode, not edit mode
      />
      <Footer />
    
    <Dialog
      open={backConfirmOpen}
      onClose={() => setBackConfirmOpen(false)}
    >
      <DialogTitle>Leave Page?</DialogTitle>

      <DialogContent>
        Are you sure you want to go back to the Employees page? Any unsaved changes may be lost.
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setBackConfirmOpen(false)}>
          Cancel
        </Button>

        <Button
          color="primary"
          variant="contained"
          sx={{ mr: 2 , backgroundColor: "#B21102", "&:hover": {backgroundColor: "#990F02"}}}
          onClick={() => {
            setBackConfirmOpen(false);
            navigate("/employees");
          }}
        >
          Yes, Leave
        </Button>
      </DialogActions>
    </Dialog>
    
    
    </>

        

  );
};

export default AddEmployee;
